//Library Imports
import { RootState } from "store";
import { useSelector } from "react-redux";
import { FC, useEffect, useState, memo } from "react";
import styled from "styled-components";

//Local Imports
import { TAB_AUDIENCE } from "constants/paths";
import Audience from "modules/Campaigns/Audience/Audience";
import AudienceAccounts from "../Accounts/AudienceAccounts";
import AudienceLists from "../Lists/AudienceLists";
import AudiencePeople from "../People/AudiencePeople";
import AudienceHeader from "./AudienceHeader";
import AudienceSearch from "../Search/AudienceSearch";
import AudienceListView from "../Lists/AudienceListView";
import AudienceHeaderSticky from "./AudienceHeaderSticky";
import {
  getRecommendedLists,
  getRecommendedPeople,
  resetRecommendedContacts,
  resetRecommendedLists,
} from "modules/Campaigns/CampaignAssets/actions";
import { resetAudienceLists } from "../Lists/actions";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import DetailProfile from "../People/DetailProfile";
import AudienceSearchTab from "./AudienceSearchTab";

interface IAudienceWrapper {
  page?: string;
  tab?: string;
  subtab?: string;
}

const AudienceWrapper: FC<IAudienceWrapper> = (props) => {
  const { page, tab, subtab } = props;

  // Local States
  // for creating new list
  const [showNewListAsider, setShowNewListAsider] = useState(false);
  const [tabState, setTabState] = useState("all");
  const [showEditContactAsider, setShowEditContactAsider] = useState(false);
  const [showImportListAsider, setShowImportListAsider] = useState(false);
  const [sortByFilter, setSortByFilter] = useState(-1);
  const [isListView, setIsListView] = useState(localStorage.getItem("isListView") === "true");

  // Redux States
  const showDetailProfile = useSelector((state: RootState) => state.audience.showDetailProfile);
  const articleSidebarPreviewInDetailProfile = useSelector(
    (state: RootState) => state.uiReducer.articleSidebarPreviewInDetailProfile
  );

  const showEditContactAsiderHandler = (value: boolean) => {
    setShowEditContactAsider(value);
  };

  useEffect(() => {
    if (!showDetailProfile) {
      setShowEditContactAsider(false);
    }
  }, [showDetailProfile]);

  useEffect(() => {
    getRecommendedLists();
    getRecommendedPeople();
    return () => {
      // reset get recommended lists and people
      resetAudienceLists();
      resetRecommendedLists();
      resetRecommendedContacts();
    };
  }, []);

  return (
    <Wrapper>
      {/* Common Header Component for Audience Pages */}
      <AudienceHeaderSticky />
      {/* Common Header Component for Audience Pages */}
      <AudienceHeader
        showNewListAsider={showNewListAsider}
        setShowNewListAsider={setShowNewListAsider}
        showImportListAsider={showImportListAsider}
        setShowImportListAsider={setShowImportListAsider}
        tabState={"all"}
        isListView={isListView}
        setIsListView={setIsListView}
        sortByFilter={sortByFilter}
        setSortByFilter={setSortByFilter}
      />

      {/* Common Search Tab Component for Audience Pages, further break down inside it */}
      {/* Pills menu for selecting pages as Audience Tab */}
      {/* {tab === TAB_AUDIENCE.VIEW ? null : <AudienceTab page={page} />} */}
      {/* Redirecting to the pages depending on the routes */}
      {page === undefined || page === "/" ? (
        <Audience />
      ) : page === TAB_AUDIENCE.ACCOUNTS ? (
        <AudienceAccounts />
      ) : page === TAB_AUDIENCE.LISTS ? (
        tab === TAB_AUDIENCE.VIEW ? (
          <AudienceListView
            showImportListAsider={showImportListAsider}
            setShowImportListAsider={setShowImportListAsider}
            tabState={"all"}
            setTabState={setTabState}
            page={page}
          />
        ) : (
          <AudienceLists
            setShowNewListAsider={setShowNewListAsider}
            isListView={isListView}
            setIsListView={setIsListView}
            sortByFilter={sortByFilter}
            setSortByFilter={setSortByFilter}
            tabState={"all"}
            setTabState={setTabState}
          />
        )
      ) : page === TAB_AUDIENCE.PEOPLE ? (
        <AudiencePeople page={page} tabState={"all"} setTabState={setTabState} />
      ) : (
        <AudienceSearch />
      )}
      <FloatingSidebarTwo
        showEditContactAsiderHandler={showEditContactAsiderHandler}
        showEditContactAsider={showEditContactAsider}
        isToggle={showDetailProfile}
        ProfileSidebar={true}
        className="detail-person-view"
        articleSidebarPreviewInDetailProfile={articleSidebarPreviewInDetailProfile}
      >
        <DetailProfile showEditContactAsiderHandler={showEditContactAsiderHandler} />
      </FloatingSidebarTwo>
    </Wrapper>
  );
};

export default memo(AudienceWrapper);

const Wrapper = memo(styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 70px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 50px 65px 0 65px;
  }
  h3 {
    color: #424b50;
    font-size: 23px;
    font-weight: 600;
    margin: 0 0 10px 0;
    display: block;
    font-family: "Roboto Slab", serif;
  }
`);
